import { normalizeContactEmail } from './contactEmails';

export interface ContactEmailBounceFields {
    contactEmail: string;
    bouncedEmail: string | null;
    emailBouncedAt: Date | string | null;
    emailBounceReason: string | null;
}

export interface ContactEmailBounce {
    bouncedAt: Date | string;
    reason: string | null;
}

/**
 * A bounce only applies to the address that bounced, so changing the contact's
 * email clears it without every write path needing to reset the bounce columns.
 */
export function getActiveContactEmailBounce(
    contact: ContactEmailBounceFields | null | undefined,
): ContactEmailBounce | null {
    if (!contact?.emailBouncedAt || !contact.bouncedEmail) {
        return null;
    }

    if (
        normalizeContactEmail(contact.bouncedEmail) !== normalizeContactEmail(contact.contactEmail)
    ) {
        return null;
    }

    return {
        bouncedAt: contact.emailBouncedAt,
        reason: contact.emailBounceReason,
    };
}
